
    import {
        defineComponent, PropType, unref, SetupContext,
    } from 'vue';
    import CheckBoxInputList from '@ve/components/inputs/CheckBoxInputList.vue';
    import CheckBoxInput from '@fr/vue/components/inputs/CheckBoxInput.vue';
    import RadioInput from '@ve/components/inputs/RadioInput.vue';
    import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import FilterItemPosition from '@ve/components/filters/common/components/filterItemPosition/FilterItemPosition.vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethodsAbstract/FilterAttributeMethodsAbstract';
    import { IFilterAttribute } from '@ve/components/filters/common/types';
    import useFilterListRender from '../common/useFilterListRender';

    export default defineComponent({
        name: 'FilterListRender',
        model: {
            prop: 'selected',
            event: 'change',
        },
        components: {
            FilterListItem,
            FilterItemPosition,
            TextCommon,
            HintTooltip,
            RadioInput,
            CheckBoxInputList,
            CheckBoxInput,
        },
        props: {
            filterAttributeMethods: {
                type: Object as PropType<FilterAttributeMethods<IFilterAttribute, any>>,
                required: true,
            },
            firstCheckboxName: {
                type: String,
                default: '',
            },
            selected: {
                type: [Array, Number] as PropType<number[] | number>,
                default: 0,
            },
            filteredEntities: {
                type: Array as PropType<any[] | any[][]>,
                default: () => [],
                required: true,
            },
            allEntities: {
                type: Array as PropType<any[] | any[][]>,
                default: () => [],
                required: true,
            },
        },
        setup(props, { emit }: SetupContext) {
            const {
                anySelectedModelArray,
                anySelectedModelNumber,
                selectedValues,
                selectedOneAttribute,
                listRender,
                countAllEntities,
                isDisabledAttributeFilter,
                isModelValuesArray,
                isVisibleAttributeFilter,

            } = useFilterListRender(props, emit);
            return {
                anySelectedModelArray,
                anySelectedModelNumber,
                selectedValues,
                selectedOneAttribute,
                listRender,
                countAllEntities,
                isDisabledAttributeFilter,
                isVisibleAttributeFilter,
                isModelValuesArray,
                ComponentBoxList: unref(isModelValuesArray) ? CheckBoxInputList : RadioInput,
            };
        },
    });
